import { Link } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { LogoMark } from "./Logo";
import { DRIVER, INSTAGRAM_URL, NAV_LINKS } from "@/lib/content";
import { scrollToId } from "@/lib/scroll";
import { useLang } from "@/context/LangContext";

export const Footer = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end end"] });
  const y = useTransform(scrollYProgress, [0, 1], ["40%", "0%"]);
  const { t, lang } = useLang();

  return (
    <footer ref={ref} data-testid="site-footer" className="relative overflow-hidden border-t border-white/10 bg-ink px-5 pt-16 md:px-10">
      <div className="mx-auto grid max-w-[1600px] grid-cols-2 gap-10 md:grid-cols-4">
        <div className="col-span-2">
          <LogoMark className="h-10 w-auto" />
          <p className="mt-5 max-w-xs text-sm text-zinc-400">{DRIVER.firstName} {DRIVER.lastName} · #{DRIVER.number} · {DRIVER.team} · {lang === "en" ? "Italian F4 Championship" : DRIVER.championship}</p>
        </div>
        <div className="flex flex-col gap-2">
          <p className="label-mono mb-2 text-white">{t.footer.sections}</p>
          {NAV_LINKS.map((id) => (
            <button key={id} onClick={() => scrollToId(id)} data-testid={`footer-link-${id}`} className="w-fit text-left text-sm text-zinc-300 hover:text-volt">{t.nav[id]}</button>
          ))}
        </div>
        <div className="flex flex-col gap-2">
          <p className="label-mono mb-2 text-white">{t.footer.social}</p>
          <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="text-sm text-zinc-300 hover:text-volt" data-testid="footer-instagram">Instagram</a>
          <a href={`mailto:${DRIVER.email}`} className="text-sm text-zinc-300 hover:text-volt" data-testid="footer-email">Email</a>
          <Link to="/admin/login" className="mt-4 text-xs text-zinc-400 hover:text-white" data-testid="footer-admin-link">{t.footer.admin}</Link>
        </div>
      </div>
      <div className="mx-auto mt-16 max-w-[1600px] overflow-hidden">
        <motion.svg style={{ y }} viewBox="0 0 1000 178" className="block h-auto w-full" aria-label="Pasquinetti" data-testid="footer-wordmark">
          <text x="0" y="138" textLength="1000" lengthAdjust="spacingAndGlyphs" fill="#1E3A8F"
            style={{ fontFamily: '"Big Shoulders Display", sans-serif', fontWeight: 900, fontSize: 180, textTransform: "uppercase" }}>
            PASQUINETTI
          </text>
        </motion.svg>
      </div>
      <div className="mx-auto flex max-w-[1600px] justify-between border-t border-white/10 py-5 font-mono text-xs uppercase tracking-[0.3em] text-zinc-400">
        <span>© {new Date().getFullYear()} {DRIVER.firstName} {DRIVER.lastName}</span>
        <span>#77 · Made in Italy</span>
      </div>
    </footer>
  );
};
